module.exports = __webpack_public_path__ + "media/images/icons/consultation-01-fa7119fbcf317df5c6476c4c235ac570.svg";